// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import * as React from "react";
import "../features/arena/ArenaLobby.css";
import { arenaRequest } from "../features/arena/api.jsx";
import * as jsxRuntime from "react/jsx-runtime";
import { de } from "../features/arena/ArenaDialog.jsx";
import { IconTrophy } from "../components/icons.jsx";
import { ma } from "../features/arena/ArenaMedia.jsx";
import { Ji } from "../features/arena/ArenaMedia.jsx";
import { ArenaMedia } from "../features/arena/ArenaMedia.jsx";
import { IconPlus } from "../components/icons.jsx";
import { IconSword } from "../components/icons.jsx";
import { IconHeart } from "../components/icons.jsx";
import { IconRefresh } from "../components/icons.jsx";
import { IconTrash } from "../components/icons.jsx";
import { IconSwords } from "../components/icons.jsx";
import { IconFlame } from "../components/icons.jsx";
import { IconHistory } from "../components/icons.jsx";
import { IconArrowRight } from "../components/icons.jsx";
import { ArenaDeckPicker } from "../features/arena/ArenaDeckPicker.jsx";
import { ArenaDialog } from "../features/arena/ArenaDialog.jsx";
import { ArenaOnlineBattle } from "../features/arena/ArenaOnlineBattle.jsx";
import { ArenaHistory } from "../features/arena/ArenaHistory.jsx";
import { IconCards } from "../components/icons.jsx";
import { IconSparkles } from "../components/icons.jsx";
export function ArenaPage({
  onNotice: u
}) {
  const [battlePreviewOpen, setBattlePreviewOpen] = React.useState(false);
  const [activeBattleId, setActiveBattleId] = React.useState(null);
  const [historyOpen, setHistoryOpen] = React.useState(false);
  React.useEffect(() => {
    const controller = new AbortController();
    arenaRequest("battle/state", {}, controller.signal).then(result => {
      if (!controller.signal.aborted && (result.battle || result.queue)) {
        setActiveBattleId(result.battle?.battleId ?? null);
        setBattlePreviewOpen(true);
      }
    }).catch(() => {});
    return () => controller.abort();
  }, []);
  const [o, m] = React.useState(null),
    [r, g] = React.useState(!0),
    [j, B] = React.useState(""),
    [U, N] = React.useState(!1),
    y = React.useRef(!1),
    [X, M] = React.useState(null),
    [R, H] = React.useState(null),
    [Y, P] = React.useState(""),
    W = React.useRef(!0),
    ee = React.useCallback(async te => {
      g(!0), B("");
      try {
        const Z = await arenaRequest("state", {}, te);
        W.current && !te?.aborted && m(Z);
      } catch (Z) {
        W.current && !te?.aborted && B(Z instanceof Error ? Z.message : "Не удалось загрузить арену");
      } finally {
        W.current && !te?.aborted && g(!1);
      }
    }, []);
  React.useEffect(() => {
    W.current = !0;
    const te = new AbortController();
    return ee(te.signal), () => {
      W.current = !1, te.abort();
    };
  }, [ee]);
  async function ie(te, Z, V) {
    if (!y.current) {
      y.current = !0, N(!0), P("");
      try {
        const ae = await arenaRequest(te, Z);
        if (!W.current) return;
        m(ae), M(null), H(null), u(V);
      } catch (ae) {
        W.current && P(ae instanceof Error ? ae.message : "Не удалось изменить колоду");
      } finally {
        y.current = !1, W.current && N(!1);
      }
    }
  }
  const w = o?.deck ?? [],
    I = o?.stats,
    ne = U || r || !o || !!j,
    oe = w.find(te => te.slot === X);
  function T(te) {
    P(""), M(te);
  }
  function D(te) {
    P(""), te === "auto" && w.length === 0 ? ie("deck/auto", {}, "Колода собрана") : H(te);
  }
  function le(te) {
    ie("deck/slot", {
      slot: X,
      cardId: te.id,
      rarity: te.rarity
    }, oe ? "Карта заменена" : "Карта добавлена в колоду");
  }
  return jsxRuntime.jsxs("section", {
    className: `${de.page} arena-lobby`,
    "aria-label": "Арена",
    children: [jsxRuntime.jsx("header", {
      className: de.hero,
      children: jsxRuntime.jsxs("div", {
        className: de.heading,
        children: [jsxRuntime.jsx("h1", {
          children: "АРЕНА"
        }), jsxRuntime.jsx("span", {
          className: de.headingLine
        }), jsxRuntime.jsxs("span", {
          className: de.rating,
          "aria-label": `Рейтинг: ${I?.rating ?? "загрузка"}`,
          children: [jsxRuntime.jsx(IconTrophy, {}), I ? ma(I.rating) : "—"]
        })]
      })
    }), jsxRuntime.jsxs("section", {
      className: de.deckPanel,
      "aria-label": "Ваша боевая колода",
      "aria-busy": r,
      children: [jsxRuntime.jsxs("div", {
        className: de.sectionTitle,
        children: [jsxRuntime.jsx("h2", {
          children: "БОЕВАЯ КОЛОДА"
        }), jsxRuntime.jsx("span", {}), jsxRuntime.jsx("small", {
          children: r ? "…" : `${w.length} / 5`
        })]
      }), jsxRuntime.jsx("div", {
        className: de.deck,
        children: Array.from({
          length: 5
        }, (te, Z) => {
          const V = Z + 1,
            ae = w.find(Te => Te.slot === V);
          return jsxRuntime.jsxs("button", {
            type: "button",
            className: `${de.slot} ${ae ? de[Ji(ae.rarity)] : de.emptySlot}`,
            disabled: ne,
            "aria-label": ae ? `Слот ${V}: ${ae.name}, ${ae.rarity}. Заменить или убрать` : `Добавить карту в слот ${V}`,
            onClick: () => T(V),
            children: [jsxRuntime.jsx("span", {
              className: de.slotFrame,
              children: r ? jsxRuntime.jsx("span", {
                className: de.skeleton
              }) : ae ? jsxRuntime.jsxs(jsxRuntime.Fragment, {
                children: [jsxRuntime.jsx(ArenaMedia, {
                  card: ae
                }, `${ae.id}:${ae.thumbnailPath}`), jsxRuntime.jsx("span", {
                  className: de.slotNumber,
                  children: V
                }), jsxRuntime.jsx("span", {
                  className: de.cardOrnament,
                  children: "✦"
                })]
              }) : jsxRuntime.jsxs(jsxRuntime.Fragment, {
                children: [jsxRuntime.jsx(IconPlus, {}), jsxRuntime.jsxs("small", {
                  children: ["Слот ", V]
                })]
              })
            }), jsxRuntime.jsx("b", {
              title: ae?.name,
              children: ae?.name ?? "Добавить"
            }), jsxRuntime.jsx("small", {
              children: ae?.rarity ?? "карту"
            })]
          }, V);
        })
      }), jsxRuntime.jsx("p", {
        className: de.deckHint,
        children: w.length ? "Нажмите на слот, чтобы заменить или убрать карту" : "Соберите команду вручную или нажмите «Автосбор»"
      })]
    }), j && jsxRuntime.jsxs("div", {
      className: de.error,
      role: "alert",
      children: [j, jsxRuntime.jsx("button", {
        type: "button",
        onClick: () => {
          ee();
        },
        disabled: r,
        children: "Обновить"
      })]
    }), Y && X === null && !R && jsxRuntime.jsx("p", {
      className: de.error,
      role: "alert",
      children: Y
    }), jsxRuntime.jsxs("div", {
      className: de.power,
      children: [jsxRuntime.jsxs("span", {
        children: [jsxRuntime.jsx(IconSword, {}), jsxRuntime.jsx("small", {
          children: "АТК"
        }), jsxRuntime.jsx("b", {
          children: I ? ma(I.power) : "—"
        })]
      }), jsxRuntime.jsx("i", {
        children: "✧"
      }), jsxRuntime.jsxs("span", {
        children: [jsxRuntime.jsx(IconHeart, {}), jsxRuntime.jsx("small", {
          children: "ХП"
        }), jsxRuntime.jsx("b", {
          children: I ? ma(I.health) : "—"
        })]
      })]
    }), jsxRuntime.jsxs("div", {
      className: de.actions,
      children: [jsxRuntime.jsxs("button", {
        type: "button",
        className: de.secondaryButton,
        disabled: ne,
        onClick: () => D("auto"),
        children: [jsxRuntime.jsx(IconRefresh, {}), "Автосбор"]
      }), jsxRuntime.jsxs("button", {
        type: "button",
        className: de.secondaryButton,
        disabled: ne || !w.length,
        onClick: () => D("clear"),
        children: [jsxRuntime.jsx(IconTrash, {}), "Очистить"]
      })]
    }), jsxRuntime.jsxs("button", {
      type: "button",
      className: de.battleButton,
      disabled: ne || w.length !== 5,
      onClick: () => { setActiveBattleId(null); setBattlePreviewOpen(true); },
      children: [jsxRuntime.jsx(IconSwords, {}), U ? "СОХРАНЯЕМ…" : "В БОЙ"]
    }), jsxRuntime.jsxs("section", {
      className: de.stats,
      "aria-label": "Статистика арены",
      children: [jsxRuntime.jsxs("div", {
        children: [jsxRuntime.jsx(IconTrophy, {}), jsxRuntime.jsxs("span", {
          children: [jsxRuntime.jsx("small", {
            children: "ПОБЕД"
          }), jsxRuntime.jsx("b", {
            children: I ? ma(I.wins) : "—"
          })]
        })]
      }), jsxRuntime.jsxs("div", {
        children: [jsxRuntime.jsx(IconSwords, {}), jsxRuntime.jsxs("span", {
          children: [jsxRuntime.jsx("small", {
            children: "ПОРАЖЕНИЙ"
          }), jsxRuntime.jsx("b", {
            children: I ? ma(I.losses) : "—"
          })]
        })]
      }), jsxRuntime.jsxs("div", {
        children: [jsxRuntime.jsx(IconFlame, {}), jsxRuntime.jsxs("span", {
          children: [jsxRuntime.jsx("small", {
            children: "СЕРИЯ"
          }), jsxRuntime.jsx("b", {
            children: I ? ma(I.streak) : "—"
          })]
        })]
      })]
    }), jsxRuntime.jsxs("button", {
      type: "button",
      className: de.history,
      disabled: !o,
      onClick: () => setHistoryOpen(true),
      children: [jsxRuntime.jsx(IconHistory, {}), jsxRuntime.jsx("span", {
        children: "История сражений"
      }), jsxRuntime.jsx(IconArrowRight, {})]
    }), historyOpen && jsxRuntime.jsx(ArenaHistory, {
      onClose: () => setHistoryOpen(false),
      onBattle: battleId => { setHistoryOpen(false); setActiveBattleId(battleId); setBattlePreviewOpen(true); }
    }), battlePreviewOpen && jsxRuntime.jsx(ArenaOnlineBattle, {
      battleId: activeBattleId,
      onFinished: () => ee(),
      onClose: () => { setBattlePreviewOpen(false); ee(); }
    }), X !== null && jsxRuntime.jsx(ArenaDeckPicker, {
      slot: X,
      current: oe,
      busy: U,
      mutationError: Y,
      onClose: () => M(null),
      onSelect: le,
      onRemove: () => {
        ie("deck/slot/remove", {
          slot: X
        }, "Карта убрана из колоды");
      }
    }, X), R && jsxRuntime.jsx(ArenaDialog, {
      title: R === "clear" ? "Очистить колоду?" : "Пересобрать колоду?",
      busy: U,
      onClose: () => H(null),
      children: jsxRuntime.jsxs("div", {
        className: de.confirmBody,
        children: [R === "clear" ? jsxRuntime.jsx(IconCards, {}) : jsxRuntime.jsx(IconSparkles, {}), jsxRuntime.jsx("p", {
          children: R === "clear" ? "Все пять слотов будут освобождены. Карты останутся в вашей коллекции." : "Автосбор заменит текущую колоду доступными сильными картами с учётом правил арены."
        }), Y && jsxRuntime.jsx("p", {
          className: de.error,
          role: "alert",
          children: Y
        }), jsxRuntime.jsxs("div", {
          className: de.actions,
          children: [jsxRuntime.jsx("button", {
            type: "button",
            className: de.secondaryButton,
            disabled: U,
            onClick: () => H(null),
            children: "Отмена"
          }), jsxRuntime.jsx("button", {
            type: "button",
            className: R === "clear" ? de.dangerButton : de.primaryButton,
            disabled: U,
            onClick: () => {
              ie(`deck/${R}`, {}, R === "clear" ? "Колода очищена" : "Колода собрана");
            },
            children: U ? "Сохраняем…" : R === "clear" ? "Очистить" : "Собрать"
          })]
        })]
      })
    })]
  });
}
